(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6314],{

/***/ 95007:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offers/[offer]",
      function () {
        return __webpack_require__(84016);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7149);






var BreadCrumbs = function(props) {
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), breadcrumbs = ref1[0], setBreadcrumbs = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), lastCrumb = ref2[0], setLastCrumb = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), offerPageName = ref3[0], setOfferPageName = ref3[1];
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().locale;
    var last = [];
    var evaluateBreadCrumb = function(value) {
        var breadCrumbValue = value && value[0] && value[0].href;
        switch(true){
            case (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("portable-storage")) && (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("residential")) || (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("entreposage-mobile")) && (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("residentiel")):
                if (locale === "en") {
                    last[0].label = "Residential Portable Storage";
                } else {
                    last[0].label = "Entreposage mobile r\xe9sidentiel";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("portable-storage")) && (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("business")) || (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("entreposage-mobile")) && (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("commercial")):
                if (locale === "en") {
                    last[0].label = "Portable Storage Containers for Business";
                } else {
                    last[0].label = "Conteneurs mobiles pour entreposage commercial";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case breadCrumbValue && (breadCrumbValue === "/portable-storage/moving" || breadCrumbValue === "/entreposage-mobile/demenagement"):
                if (locale === "en") {
                    last[0].label = "Portable Storage for Moving";
                } else {
                    last[0].label = "Entreposage mobile pour d\xe9m\xe9nager";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("portable-storage")) && (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("long-distance-moving")) || (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("entreposage-mobile")) && (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("demenagement-longue-distance")):
                if (locale === "en") {
                    last[0].label = "Long Distance Moving";
                } else {
                    last[0].label = "D\xe9m\xe9nagement sur longue distance";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case breadCrumbValue && (breadCrumbValue === "/packing-supplies" || breadCrumbValue === "/fournitures-emballage"):
                if (locale === "en") {
                    last[0].label = "Packing Supplies";
                } else {
                    last[0].label = "Fournitures de d\xe9m\xe9nagement et d'emballage";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case breadCrumbValue && (breadCrumbValue === "/self-storage/business" || breadCrumbValue === "/entreposage-libre-service/commercial"):
                if (locale === "en") {
                    last[0].label = "Business Self Storage";
                } else {
                    last[0].label = "Entreposage commercial en libre-service";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case breadCrumbValue && (breadCrumbValue === "/self-storage/moving" || breadCrumbValue === "/entreposage-libre-service/demenagement"):
                if (locale === "en") {
                    last[0].label = "Moving Storage";
                } else {
                    last[0].label = "Entreposage mobile";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case breadCrumbValue && (breadCrumbValue === "/terms-of-service" || breadCrumbValue === "/conditions-dutilisation"):
                if (locale === "en") {
                    last[0].label = "User Agreement";
                } else {
                    last[0].label = "ENTENTE SUR LES CONDITIONS D’UTILISATION";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case breadCrumbValue && (breadCrumbValue === "/careers" || breadCrumbValue === "/carrieres"):
                if (locale === "en") {
                    last[0].label = "Careers";
                } else {
                    last[0].label = "Carrieres";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            default:
                break;
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var pageName =  true && window.location.pathname.split("/");
        var pathWithoutQuery;
        if (pageName[2] === "offers" || pageName[2] === "offres" || pageName[2] === "blogue" || pageName[2] === "blog") {
            setOfferPageName(pageName[2]);
            pathWithoutQuery = "/".concat(pageName[2], "/").concat(pageName[3]);
        } else {
            pathWithoutQuery = locale === "en" ? props.path :  true && window.location.href.split("fr")[1];
        }
        pathWithoutQuery = pathWithoutQuery === null || pathWithoutQuery === void 0 ? void 0 : pathWithoutQuery.replace("#form", "");
        var pathArray = pathWithoutQuery === null || pathWithoutQuery === void 0 ? void 0 : pathWithoutQuery.split("/");
        if (locale === "en") {
            pathArray.shift();
        }
        pathArray = pathArray === null || pathArray === void 0 ? void 0 : pathArray.filter(function(path) {
            return path !== "" && !path.startsWith("?");
        });
        var breadcrumb = pathArray === null || pathArray === void 0 ? void 0 : pathArray.map(function(path, index) {
            return {
                href: "/".concat(pathArray.slice(0, index + 1).join("/")),
                label: path.charAt(0).toUpperCase() + path.slice(1).replace(/-/g, " ")
            };
        });
        last = breadcrumb.slice(-1);
        setLastCrumb(last);
        breadcrumb.splice(breadcrumb.length - 1, 1);
        setBreadcrumbs(breadcrumb);
        evaluateBreadCrumb(last);
    }, [
        router.asPath,
        locale,
         true && window.location.href, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: props.isNoMargin ? "container container-no-margin" : "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: "sv-breadcrumb",
                children: [
                    locale === "en" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                        href: "/",
                        children: "Home"
                    }),
                    locale === "fr" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                        href: "/fr/",
                        children: "Accueil"
                    }),
                    offerPageName !== "offers" && offerPageName !== "offres" && offerPageName !== "blogue" && offerPageName !== "blog" && breadcrumbs && breadcrumbs.map(function(breadcrumb) {
                        return (breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.label) === "Self storage" || (breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.label) === "Entreposage libre service" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                            href: locale === "en" ? "/en".concat(breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.href, "/") : "/fr".concat(breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.href, "/"),
                            className: "breadcrumbs",
                            children: breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.label
                        }, breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.href) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                            active: true,
                            href: "".concat(breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.href, "/"),
                            className: "breadcrumbs",
                            children: breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.label
                        }, breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.href);
                    }),
                    offerPageName && offerPageName.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                        href: locale === "en" ? "/en/".concat(offerPageName, "/") : "/fr/".concat(offerPageName, "/"),
                        children: offerPageName
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                        active: true,
                        children: (ref = lastCrumb[0]) === null || ref === void 0 ? void 0 : ref.label
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BreadCrumbs);


/***/ }),

/***/ 84016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _components_breadcrumbs_breadcrumb__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5553);
/* harmony import */ var _components_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55088);
/* harmony import */ var _context_HeaderFooterContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2621);
/* harmony import */ var _services_home_setBrands__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76784);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13135);













var CardData = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9238), __webpack_require__.e(8068)]).then(__webpack_require__.bind(__webpack_require__, 38068));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38068)
            ];
        }
    }
});
var DynamicPage = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4885), __webpack_require__.e(1608), __webpack_require__.e(1664), __webpack_require__.e(4585), __webpack_require__.e(7536), __webpack_require__.e(1909), __webpack_require__.e(9700), __webpack_require__.e(1111), __webpack_require__.e(8020), __webpack_require__.e(4156)]).then(__webpack_require__.bind(__webpack_require__, 63102));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63102)
            ];
        }
    }
});
var SpecificOfferItem = function(param) {
    var hostUrl = param.hostUrl, dealSlugRes = param.dealSlugRes;
    var ref, ref1, ref2;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), dealSlugData = ref3[0], setDealsSlugData = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), htmlData = ref4[0], setHtmlData = ref4[1];
    var pathWithoutQuery = router.asPath.split("?")[0];
    var dealSlugDataL;
    var getOfferData = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        dealSlugDataL = (ref = dealSlugRes === null || dealSlugRes === void 0 ? void 0 : dealSlugRes.data[0]) === null || ref === void 0 ? void 0 : ref.attributes;
        setHtmlData(dealSlugDataL);
        setDealsSlugData(dealSlugDataL);
        var newArray = [
            {
                lan: dealSlugDataL === null || dealSlugDataL === void 0 ? void 0 : dealSlugDataL.locale,
                slugValue: dealSlugDataL === null || dealSlugDataL === void 0 ? void 0 : dealSlugDataL.Slug
            },
            {
                lan: (ref2 = dealSlugDataL === null || dealSlugDataL === void 0 ? void 0 : (ref1 = dealSlugDataL.localizations) === null || ref1 === void 0 ? void 0 : ref1.data[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : ref3.locale,
                slugValue: (ref5 = dealSlugDataL === null || dealSlugDataL === void 0 ? void 0 : (ref4 = dealSlugDataL.localizations) === null || ref4 === void 0 ? void 0 : ref4.data[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.attributes) === null || ref6 === void 0 ? void 0 : ref6.Slug
            }, 
        ];
        if (newArray[0].lan) {
            sessionStorage.setItem("offCords", JSON.stringify(newArray));
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        getOfferData();
        setHtmlData(dealSlugData);
    }, [
        locale,
        dealSlugRes,
        dealSlugData
    ]);
    var headerFooterData = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_context_HeaderFooterContext__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP);
    var headerFooter = headerFooterData.headerFooter;
    var isContext = !!headerFooter[0];
    var seoProps = (0,_components_utility__WEBPACK_IMPORTED_MODULE_6__/* .getSEOProps */ .RN)((ref = dealSlugRes === null || dealSlugRes === void 0 ? void 0 : dealSlugRes.data[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.SEO, router);
    var getContextData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            var defaultBrand, contextData, brands;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = _utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .BRAND_NAME_EN */ .Vp;
                        if (locale === "fr") defaultBrand = _utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .BRAND_NAME_FR */ .Fj;
                        return [
                            4,
                            (0,_services_home_setBrands__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(defaultBrand, locale)
                        ];
                    case 1:
                        contextData = _state.sent();
                        brands = contextData === null || contextData === void 0 ? void 0 : contextData.data;
                        headerFooterData.setHeaderFooterData(brands);
                        return [
                            2
                        ];
                }
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    var breadCrumbUrlList = (0,_components_utility__WEBPACK_IMPORTED_MODULE_6__/* .generateDynamicBCLD */ .W_)(router);
    if (htmlData === null || htmlData === void 0 ? void 0 : (ref2 = htmlData.Dynamic_Content) === null || ref2 === void 0 ? void 0 : ref2.length) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "sv-page-content",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, seoProps)),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "my-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_breadcrumbs_breadcrumb__WEBPACK_IMPORTED_MODULE_5__["default"], {
                            path: pathWithoutQuery
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbJsonLd */ .gR, {
                            itemListElements: breadCrumbUrlList
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicPage, {
                            pageData: htmlData.Dynamic_Content
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "sv-page-content deals-detail-wrapper",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, seoProps)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "my-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_breadcrumbs_breadcrumb__WEBPACK_IMPORTED_MODULE_5__["default"], {
                        path: pathWithoutQuery
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbJsonLd */ .gR, {
                        itemListElements: breadCrumbUrlList
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardData, {
                        htmlData: htmlData,
                        hostUrl: hostUrl
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (SpecificOfferItem);


/***/ }),

/***/ 66156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": function() { return /* binding */ getConvenientLocations; },
/* harmony export */   "YW": function() { return /* binding */ getHeaderAndFooterDetailsWithDefaultLocale; },
/* harmony export */   "Zy": function() { return /* binding */ getRightUnitInfo; },
/* harmony export */   "co": function() { return /* binding */ getVehicleLandingData; },
/* harmony export */   "fC": function() { return /* binding */ getCityLandingInfo; },
/* harmony export */   "fU": function() { return /* binding */ getInnerPagesWithDefaultLocale; },
/* harmony export */   "k5": function() { return /* binding */ getBrandReviews; },
/* harmony export */   "ns": function() { return /* binding */ getGoogleReviews; },
/* harmony export */   "zc": function() { return /* binding */ getOurBrands; }
/* harmony export */ });
/* unused harmony exports getGoogleReview, getHomeBodyDetailsWithDefaultLocale, getStudentSpecialContent, getValidityCity */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15122);
/* harmony import */ var _apiUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33891);




var getHeaderAndFooterDetailsWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        var data = (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getBrandLocaleUrl */ .oo(brand, locale)), "get");
                        resolve(data);
                    } catch (e) {
                        reject(e);
                    }
                })
            ];
        });
    });
    return function getHeaderAndFooterDetailsWithDefaultLocale() {
        return _ref.apply(this, arguments);
    };
}();
var getHomeBodyDetailsWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        var data = (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getHomeLocaleUrl */ .dK(brand, locale)), "get");
                        resolve(data);
                    } catch (e) {
                        reject(e);
                    }
                })
            ];
        });
    });
    return function getHomeBodyDetailsWithDefaultLocale() {
        return _ref.apply(this, arguments);
    };
}();
var getBrandReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .GOOGLE_CLIENT_REVIEWS */ .Zk), "get")
            ];
        });
    });
    return function getBrandReviews() {
        return _ref.apply(this, arguments);
    };
}();
var getOurBrands = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .GET_OUR_BRANDS */ .e), "get")
            ];
        });
    });
    return function getOurBrands() {
        return _ref.apply(this, arguments);
    };
}();
// for future lcode include
var getGoogleReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lcode) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getClientReviews */ .Vf(lcode)), "get")
            ];
        });
    });
    return function getGoogleReviews(lcode) {
        return _ref.apply(this, arguments);
    };
}();
var getGoogleReview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lcode, locale) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getClientReview */ .tw(lcode, locale)), "get")
            ];
        });
    });
    return function getGoogleReview(lcode, locale) {
        return _ref.apply(this, arguments);
    };
}();
// lat, lng, brand, limit,
var getConvenientLocations = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lang, cords) {
        var ncards;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            ncards = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 3;
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .CONVENIENT_LOCATIONS */ .vi, "?lat=").concat(cords === null || cords === void 0 ? void 0 : cords.latitude, "&lng=").concat(cords === null || cords === void 0 ? void 0 : cords.longitude, "&brand=as&limit=").concat(ncards, "&lang=").concat(lang), "get")
            ];
        });
    });
    return function getConvenientLocations(lang, cords) {
        return _ref.apply(this, arguments);
    };
}();
// brand section
var getInnerPagesWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(innerPageName) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getInnerPagesUrl */ .zP(innerPageName, brand, locale)), "get")
            ];
        });
    });
    return function getInnerPagesWithDefaultLocale(innerPageName) {
        return _ref.apply(this, arguments);
    };
}();
// student special content
var getStudentSpecialContent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(defaultLink, locale, brand) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getStudentSpecialUrl */ .Sh(defaultLink, locale, brand)), "get")
            ];
        });
    });
    return function getStudentSpecialContent(defaultLink, locale, brand) {
        return _ref.apply(this, arguments);
    };
}();
// city landing page
var getCityLandingInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getCityLandingInfo */ .fC(slug, brand, locale)), "get")
            ];
        });
    });
    return function getCityLandingInfo(slug) {
        return _ref.apply(this, arguments);
    };
}();
// city landing page
var getVehicleLandingData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getVehicleLandingInfo */ .CZ(slug, brand, locale)), "get")
            ];
        });
    });
    return function getVehicleLandingData(slug) {
        return _ref.apply(this, arguments);
    };
}();
// right units
var getRightUnitInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getRightUnitInfo */ .Zy(brand, locale)), "get")
            ];
        });
    });
    return function getRightUnitInfo() {
        return _ref.apply(this, arguments);
    };
}();
// validate city for facility slug
var getValidityCity = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug, brand) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getValidateCity */ .e$(slug, brand)), "get")
            ];
        });
    });
    return function getValidityCity(slug, brand) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 76784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66156);



var SetBrandsContext = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var brand, locale, ref, result, data;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "dp", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
                    return [
                        4,
                        Promise.all([
                            (0,___WEBPACK_IMPORTED_MODULE_0__/* .getHeaderAndFooterDetailsWithDefaultLocale */ .YW)(brand, locale)
                        ])
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        (ref = result[0]) === null || ref === void 0 ? void 0 : ref.data
                    ];
                case 2:
                    data = _state.sent() || null;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function SetBrandsContext() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (SetBrandsContext);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1217,9812,3640,9774,2888,179], function() { return __webpack_exec__(95007); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);